import React from 'react';

import {Button, Confirm, Form, Grid} from 'semantic-ui-react';
import PropTypes from 'prop-types';
import users from 'img/users.png';
import managers from 'img/managers.png';
import {upperFirst} from 'lodash';

export const extractBillingAddress = (address) => {
    let billingAddress;

    if (address) {
        billingAddress = Object.keys(address).reduce((acc, field) => {
            if (address[field]) {
                return acc ? acc + ', ' + address[field] : address[field];
            }
            return acc;
        }, '');
    }

    return billingAddress;
};



function CorporationDetails({selectedUserDetails, onShowManagers, onShowUsers, onEditDetails, onAddManager, onUndeleteUser, onDeleteUser}) {
    const [state, setState] = React.useState({
        openAttributeModal: false,
        openUserModal: false,
        selectedAttribute: {},
    });

    const handleUserDeleteClick = () => {
        setState({...state, openUserModal: true});
    };

    const cancelDelete = () => {
        return setState({...state, openUserModal: false, openAttributeModal: false});
    };

    const confirmDeleteUser = () => {
        if (selectedUserDetails.deleted) {
            onUndeleteUser(selectedUserDetails.id);
        } else {
            onDeleteUser(selectedUserDetails.id);
        }
        setState({...state, openUserModal: false});
    };

    const userName = `${upperFirst(selectedUserDetails.firstName)}`;
    const headerTitle = `Details for : ${userName} (Corporation)`;
    const billingAddress = extractBillingAddress(selectedUserDetails.address);
    const deleteUnDeleteTitle = selectedUserDetails.deleted ? 'Undelete' : 'Delete';

    return (
        <div id="details-wrapper">
            <div className="user-details">
                <div className="user-hierarchy-wrapper">
                    <div>
                        <h3 className="user-details-header">{headerTitle}</h3>
                        <Grid>
                            <Form>
                                <Form.Field>
                                    <div className="user-field__title">Business Name</div>
                                    <div className="user-field__value">{userName}</div>
                                </Form.Field>
                                <Form.Field>
                                    <div className="user-field__title">Industry</div>
                                    <div className="user-field__value">{selectedUserDetails.lastName}</div>
                                </Form.Field>
                                <Form.Field>
                                    <div className="user-field__title">CRM Account ID</div>
                                    <div className="user-field__value">{selectedUserDetails.crmId}</div>
                                </Form.Field>
                                <Form.Field>
                                    <div className="user-field__title">crmAccountGuid</div>
                                    <div className="user-field__value">{selectedUserDetails.crmAccountGuid}</div>
                                </Form.Field>
                                <Form.Field>
                                    <div className="user-field__title">Email</div>
                                    <div className="user-field__value">{selectedUserDetails.email}</div>
                                </Form.Field>
                                <Form.Field>
                                    <div className="user-field__title">Phone</div>
                                    <div className="user-field__value">{selectedUserDetails.phone}</div>
                                </Form.Field>
                                <Form.Field>
                                    <div className="user-field__title">Deleted</div>
                                    <div className="user-field__value">{selectedUserDetails.deleted ? 'true' : 'false'}</div>
                                </Form.Field>
                                <Form.Field>
                                    <div className="user-field__title">Billing Address</div>
                                    <div className="user-field__value billing">{billingAddress}</div>
                                </Form.Field>
                                <Form.Field>
                                    <div className="user-field__title">Licensed user notes</div>
                                    <div className="user-field__value license">{selectedUserDetails.licenseNotes}</div>
                                </Form.Field>
                            </Form>
                        </Grid>
                        <div className="edit-options">
                            <Button basic className="edit-details" onClick={() => onEditDetails(selectedUserDetails.id)}>Edit</Button>
                            <Button basic className="delete-user" onClick={handleUserDeleteClick}>{deleteUnDeleteTitle}</Button>
                            <Button basic className="add-manager" onClick={() => onAddManager(selectedUserDetails.id)}>Add manager</Button>
                        </div>
                    </div>
                    <div className="hierarchy-buttons">
                        <div>
                            <img alt="" src={managers}/>
                            <Button className="show-managers" basic onClick={() => {
                                onShowManagers(selectedUserDetails.id);
                            }}>
                                Managers
                            </Button>
                        </div>
                        <div>
                            <img alt="" src={users}/>
                            <Button basic className="show-users" onClick={() => onShowUsers(selectedUserDetails.id)}>Users</Button>
                        </div>
                    </div>
                </div>
            </div>
            <Confirm
                open={state.openUserModal}
                header={`${deleteUnDeleteTitle} User`}
                content={`Are you sure that you want to ${deleteUnDeleteTitle.toLowerCase()} ${userName}?`}
                confirmButton="Yes"
                cancelButton="No"
                onCancel={cancelDelete}
                onConfirm={confirmDeleteUser}
            />
        </div>
    );
}

CorporationDetails.propTypes = {
    selectedUserDetails: PropTypes.object,
    onShowUsers: PropTypes.func.isRequired,
    onShowManagers: PropTypes.func.isRequired,
    onEditDetails: PropTypes.func.isRequired,
    onAddManager: PropTypes.func.isRequired,
    onUndeleteUser: PropTypes.func.isRequired,
    onDeleteUser: PropTypes.func.isRequired,
};

export default CorporationDetails;